import React, { useEffect, useState } from 'react';
import { adminContactService } from '../services';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { notifyError, notifyInfo, notifySuccess } from '../utils/toast';

const Contacts = () => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchContacts();
    }, []);

    const fetchContacts = async () => {
        try {
            const response = await adminContactService.getAll();
            setContacts(response.data.data || []);
        } catch (error) {
            console.error('Error fetching contacts:', error);
            notifyError('Unable to load contacts.');
        } finally {
            setLoading(false);
        }
    };

    const updateStatus = async (id, status) => {
        try {
            await adminContactService.updateStatus(id, status);
            await fetchContacts();
            notifySuccess(`Contact marked as ${status}.`);
        } catch (error) {
            console.error('Error updating contact:', error);
            notifyError('Unable to update contact status.');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this contact message?')) return;
        try {
            await adminContactService.delete(id);
            notifySuccess('Contact deleted successfully.');
            await fetchContacts();
        } catch (error) {
            notifyError('Unable to delete contact.');
        }
    };

    return (
        <div>
            <h1 className="mb-8 text-4xl font-bold text-gray-800">Contacts</h1>
            {loading ? (
                <div className="py-12 text-center">
                    <div className="inline-block h-12 w-12 animate-spin rounded-full border-b-2 border-emerald-600"></div>
                </div>
            ) : (
                <div className="overflow-hidden rounded-lg bg-white shadow-lg">
                    <table className="w-full">
                        <thead className="bg-emerald-600 text-white">
                            <tr>
                                <th className="px-6 py-3 text-left">Name</th>
                                <th className="px-6 py-3 text-left">Email</th>
                                <th className="px-6 py-3 text-left">Subject</th>
                                <th className="px-6 py-3 text-left">Status</th>
                                <th className="px-6 py-3 text-left">Received</th>
                                <th className="px-6 py-3 text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contacts.map((contact) => (
                                <tr key={contact.id} className="border-b hover:bg-gray-50">
                                    <td className="px-6 py-4">{contact.name}</td>
                                    <td className="px-6 py-4">{contact.email}</td>
                                    <td className="px-6 py-4">{contact.subject}</td>
                                    <td className="px-6 py-4">
                                        <select
                                            value={contact.status}
                                            onChange={(e) => updateStatus(contact.id, e.target.value)}
                                            className="rounded border border-gray-300 px-2 py-1"
                                        >
                                            <option value="new">New</option>
                                            <option value="in_progress">In Progress</option>
                                            <option value="resolved">Resolved</option>
                                        </select>
                                    </td>
                                    <td className="px-6 py-4">{new Date(contact.created_at).toLocaleDateString()}</td>
                                    <td className="px-6 py-4 flex gap-3">
                                        <button
                                            onClick={() => notifyInfo('Use the status dropdown to edit this contact.')}
                                            className="text-emerald-600 hover:text-emerald-800"
                                            title="Edit"
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            onClick={() => handleDelete(contact.id)}
                                            className="text-red-600 hover:text-red-800"
                                            title="Remove"
                                        >
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Contacts;
